import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import {BEFORE_UNLOAD_EVENT, CACHE_KEY_FOR_SCHEDULING} from '@Libraries/social-media-grid.library';
import {SocialMediaWizard} from '@/components/social-media-wizard';
import {renderApp} from '@Utils/renderApp.util';

function SocialMediaWizardApp(): ReactElement<any> | null {
  const [i18Loaded, setI18Loaded] = useState(false);

  const deletePrefilledDateCacheForScheduledPost = (): void => {
    window.PMW.deleteCacheItem(CACHE_KEY_FOR_SCHEDULING);
  };

  useEffect(() => {
    window.PMW.initI18next(window.PMW.LANGUAGE, () => {
      setI18Loaded(true);
    });

    window.addEventListener(BEFORE_UNLOAD_EVENT, deletePrefilledDateCacheForScheduledPost);

    return (): void => {
      window.removeEventListener(BEFORE_UNLOAD_EVENT, deletePrefilledDateCacheForScheduledPost);
    };
  }, []);

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App nonStrictModeChildren={<SocialMediaWizard {...window.reactPageProps} />}>
      <ModalContainerDeprecated />
      <ModalContainer />
      <LoadingToast />
    </App>
  );
}

renderApp(<SocialMediaWizardApp />, 'social-media-wizard-app');
